import React, { useState, useEffect } from "react";
import { useChat } from "../contexts/ChatProvider";
import { useLocale } from "../contexts/LocaleProvider";
import {
  MainContainer,
  MessageContainer,
  MessageHeader,
} from "@minchat/react-chat-ui";
import MessageInput from './message-input';
import ChatContainerFullScreen from "./message/ChatContainerFullScreen";
import CrossIcon from './icons/CrossIcon';
import ExitFullScreenIcon from "./icons/ExitFullscreenIcon";
import NewChatIcon from "./icons/newChatIcon";
import MenuIcon from "./icons/MenuIcon";
import ChatMenu from "./chat-menu/MenuModal";
import ChatSessionPanel from "./chat-sessions/SessionList";
import ChatListIcon from "./icons/ChatListIcon";
import Tooltip from "./ToolTip";

export const FullScreenWidget = ({ remoteName = "", onSend, onScreenMinimize }) => {
  const {
    hide,
    theme,
    colorSet,
    loading,
    header,
    shoji,
    showTypingIndicator,
    exitFullScreen,
    isMobile,
    sessionExpired,
    handleClickNewChat,
    openChatMenu,
    setOpenChatMenu,
    showChatList,
    setShowChatList,
    setSessionListIndex,
    setSessions
  } = useChat();
  const [deviceWidth, setDeviceWidth] = useState();
  const { t } = useLocale();
  useEffect(() => {
    function handleResize() {
      setDeviceWidth(window.outerWidth);
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const HandleExitFullScreen = () => {
    exitFullScreen();
    onScreenMinimize();
    setSessionListIndex(0);
    setSessions([]);
  }

  return (
    <div style={{ width: "100vw", height: "100%" }}>
      <div style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "0.75rem 1.5rem",
        backgroundColor: "#e5e7eb",
        position: "sticky",
        top: 0,
        zIndex: 100
      }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", padding: "0 1%", width: '100%' }}>
          <p id="ChatBotTitle" style={{ fontSize: "20px", fontWeight: "bold" }}>
            {header}
          </p>
          <div style={{ display: "flex", justifyContent: "start", gap: "10px" }}>
            <Tooltip text={t("header.newChatTooltip")} >
              <span
                className="header-action"
                onClick={showTypingIndicator ? undefined : handleClickNewChat}
                aria-disabled={showTypingIndicator}
                style={{
                  "--theme-color": theme,
                  borderRadius: "50%",
                  height: "24px",
                  width: "24px",
                  cursor: showTypingIndicator ? "wait" : "pointer",
                  opacity: showTypingIndicator ? 0.5 : 1,
                }}
              >
                <NewChatIcon color={colorSet["--message-header-text-color"] ?? "black"} />
              </span>
            </Tooltip>
            <Tooltip text={t("header.chatsTooltip")} >
              <span
                className="header-action"
                onClick={() => setShowChatList(true)}
                style={{ 
                  "--theme-color": theme, 
                  borderRadius: '50%', 
                  height: "24px",
                  width: "24px",
                }}
              >
                <ChatListIcon color={colorSet["--message-header-text-color"] ?? "black"} />
              </span>
            </Tooltip>
            {!isMobile && (
              <Tooltip text={t("header.exitFullScreenTooltip")} >
                <span
                  className="header-action"
                  onClick={HandleExitFullScreen}
                  style={{ "--theme-color": theme, cursor: 'pointer', borderRadius: '50%', height: "24px", width: "24px" }}
                >
                  <ExitFullScreenIcon color={colorSet["--message-header-text-color"] ?? "black"} />
                </span>
              </Tooltip>
            )}
            <Tooltip text={t("common.close")} >
              <span
                className="header-action"
                onClick={() => { hide() }}
                style={{ "--theme-color": theme, cursor: 'pointer', borderRadius: '50%', height: "24px", width: "24px" }}
              >
                <CrossIcon color={colorSet["--message-header-text-color"] ?? "black"} />
              </span>
            </Tooltip>
          </div>
        </div>
      </div>
      <MainContainer>
        <MessageContainer>
          <div
            style={{
              height: "90%", width: "100%", backgroundColor: "white", alignItems: 'center'
            }}
          >
            <ChatContainerFullScreen
              remoteName={remoteName}
              loading={loading}
              showTypingIndicator={showTypingIndicator}
              deviceWidth={deviceWidth}
            />
          </div>
        </MessageContainer>
      </MainContainer>
      <div style={{
        position: "sticky",
        bottom: 20,
        background: "white",
        zIndex: 100,
        marginTop: "5px",
        maxWidth: deviceWidth <= 1024 ? (deviceWidth - 200) + "px" : "940px",
        width: deviceWidth <= 1024 ? (deviceWidth - 200) + "px" : "clamp(810px, 60vw, 940px)",
        margin: "auto"
      }}>
        <MessageInput
          placeholder={shoji() ? "ここにメッセージを入力してください" : t("chat.default_input_placeholder")}
          isFullScreen={true}
          onSendMessage={onSend}
          showAttachButton={false}
          disabled={showTypingIndicator}
        />
        <p style={{ textAlign: "center", margin: "auto", fontSize: "12px", paddingTop: "5px" }}>{t("chat.message_input_instruction")}</p>
      </div>
      {showChatList && <ChatSessionPanel />}
    </div>
  )
}